
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Circle, Star, Target } from "lucide-react";
import { ProgressBar } from './ProgressBar';

interface FoulsSummaryCardProps {
  foulsStats: {
    averageFoulsPerGame: string;
    averageHomeFouls: string;
    averageAwayFouls: string;
    overUnderStats: {
      threshold: number;
      over: string;
      under: string;
    }[];
    mostFouls?: {
      team: string;
      average: string;
    };
    leastFouls?: {
      team: string;
      average: string;
    };
    totalFouls?: number;
  };
}

export const FoulsSummaryCard: React.FC<FoulsSummaryCardProps> = ({
  foulsStats
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-black text-lg">Fouls Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Circle className="h-4 w-4 text-orange-500" />
              <span className="text-black">Total: {foulsStats.totalFouls}</span>
            </div>
            <div className="flex items-center gap-2">
              <Circle className="h-4 w-4 text-orange-500" />
              <span className="text-black">Average: {foulsStats.averageFoulsPerGame}</span>
            </div>
            {foulsStats.mostFouls && (
              <div className="flex items-center gap-2">
                <Star className="h-4 w-4 text-yellow-500" />
                <span className="text-black">Most: {foulsStats.mostFouls.team} ({foulsStats.mostFouls.average})</span>
              </div>
            )}
            {foulsStats.leastFouls && (
              <div className="flex items-center gap-2">
                <Target className="h-4 w-4 text-blue-500" />
                <span className="text-black">Least: {foulsStats.leastFouls.team} ({foulsStats.leastFouls.average})</span>
              </div>
            )}
          </div>

          <div className="space-y-2">
            {foulsStats.overUnderStats.map(({ threshold, over }) => (
              <div key={threshold} className="flex justify-between items-center gap-4">
                <span className="text-sm text-black w-24">Over {threshold}</span>
                <div className="flex-1">
                  <ProgressBar percentage={over} color="bg-orange-500" />
                </div>
                <span className="text-sm font-medium w-16 text-right text-black">{over}%</span>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
